/* eslint-disable @typescript-eslint/no-explicit-any */
import BigNumber from 'bignumber.js';
import { ContractJSON, TokenData, TokensData } from 'models';
import Web3 from 'web3';
import { Contract } from 'web3-eth-contract';
import { AbiItem } from 'web3-utils';

export const getContract = (
  web3: Web3,
  contractJSON: ContractJSON,
  networkId: string,
  gasPrice: string
): Contract =>
  new web3.eth.Contract(
    contractJSON.abi as AbiItem[],
    (contractJSON.networks as any)[networkId]?.address
    // TODO: left here for reference as it was the only use of gasPrice state variable (currently unused but may be needed in future)
    // { gasPrice }
  );

export const fromWei = (
  value: BigNumber | BigNumber.Value,
  decimals: number
): string =>
  new BigNumber(value || 0).div(new BigNumber(10).pow(decimals)).toString(10);

export const toWei = (amount: string | number, decimals: number): string => {
  const BNAmount = new BigNumber(amount);
  const multiplier = new BigNumber(10).pow(decimals);

  return BNAmount.times(multiplier).toString(10);
};

// export const toDecimal = (value = '0', decimals: number) =>
//   new BigNumber(value).decimalPlaces(decimals, BigNumber.ROUND_DOWN).toString();

export const contractsAvailable = (tokensData: TokensData): boolean =>
  tokensData &&
  Object.values(tokensData).every(
    (tokenData: TokenData) => !!tokenData.tokenContract?.options?.address
  );
